import { Empty } from 'antd';

import styles from './EmptyStateWithAction.module.css';

type EmptyStateWithActionProps = {
  message: string;
  actionLabel?: string;
  onAction?: () => void;
  actionIcon?: React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
};

export const EmptyStateWithAction = ({
  message,
  actionLabel,
  onAction,
  actionIcon,
  icon,
  className,
}: EmptyStateWithActionProps) => {
  return (
    <div className={`${styles.container} ${className || ''}`}>
      <Empty
        image={icon || Empty.PRESENTED_IMAGE_SIMPLE}
        description={
          <div className={styles.content}>
            <div className={styles.message}>{message}</div>
            {actionLabel && onAction && (
              <button type="button" onClick={onAction}>
                {actionIcon && <span className={styles.iconWrapper}>{actionIcon}</span>}
                <span>{actionLabel}</span>
              </button>
            )}
          </div>
        }
      />
    </div>
  );
};
